import { useImperativeFilePicker } from 'use-file-picker';
import {useEffect} from "react";
import {isEmpty, isFunction} from "lodash";

import {
    FileSizeValidator
} from "use-file-picker/validators";

import {UPLOAD_ICON, UPLOAD_REMOVE_ICON} from "./Icons";

function Upload({onFilesChange}){
    const { openFilePicker, errors, plainFiles, removeFileByReference } =
        useImperativeFilePicker({
            multiple: false,
            accept: ['.png', '.jpg', '.jpeg', '.pdf'],
            validators: [
                new FileSizeValidator({maxFileSize: 5 * 1024 * 1024})
            ],
            readFilesContent: true
        });

    useEffect(()=>{
        if(isFunction(onFilesChange)){
            onFilesChange(plainFiles);
        }
    }, [plainFiles, onFilesChange]);

    return <div className={'upload-component'}>
        <button className={'upload-button'} disabled={plainFiles.length>=3} onClick={async (event) => {
            event.preventDefault();
            openFilePicker();
        }
        }>
            <span className="icon">
                {UPLOAD_ICON}
            </span>
            Datei auswählen…
        </button>

        {!isEmpty(errors) && (
            <div className={'error'}>
                {errors[0].reason === 'MAX_AMOUNT_OF_FILES_EXCEEDED' && 'Zu viel Dateien wurden ausgewählt.'}
                {errors[0].reason === 'FILE_SIZE_TOO_LARGE' && 'Eine zu große Datei wurde ausgewählt.'}
            </div>
        )}

        {plainFiles.length > 0 && <ul>
            {plainFiles.map((file, i) => (
                <li key={i}>
                    <span className={'filename-clip'}>
                        <span className={'filename'}>{file.name}</span>
                    </span>
                    <button onClick={(event) => {
                        event.preventDefault();
                        removeFileByReference(file)}
                    }>
                        {UPLOAD_REMOVE_ICON}
                    </button>
                </li>
            ))}
        </ul>}
    </div>;
}

export default Upload;